import { supabase } from '../lib/supabase';

// Buscar todos os contextos de IA com informações das matérias e anos escolares
export const fetchContextosIa = async () => {
  try {
    const { data, error } = await supabase
      .from('contextos_ia')
      .select(`
        *,
        materias:materia_id (
          id,
          nome
        ),
        anos_escolares:ano_escolar_id (
          id,
          nome
        )
      `)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Erro ao buscar contextos de IA:', error);
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Erro ao buscar contextos de IA:', error);
    throw error;
  }
};

// Buscar contexto de IA por ID
export const fetchContextoIaById = async (id) => {
  try {
    const { data, error } = await supabase
      .from('contextos_ia')
      .select(`
        *,
        materias:materia_id (
          id,
          nome
        ),
        anos_escolares:ano_escolar_id (
          id,
          nome
        )
      `)
      .eq('id', id)
      .single();

    if (error) {
      console.error('Erro ao buscar contexto de IA:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Erro ao buscar contexto de IA:', error);
    throw error;
  }
};

// Criar novo contexto de IA
export const createContextoIa = async (contextoData) => {
  try {
    console.log('Criando contexto de IA:', contextoData);

    const { data, error } = await supabase
      .from('contextos_ia')
      .insert([{
        titulo: contextoData.titulo,
        materia_id: contextoData.materia_id,
        ano_escolar_id: contextoData.ano_escolar_id,
        contexto: contextoData.contexto,
        ativo: contextoData.ativo !== undefined ? contextoData.ativo : true
      }])
      .select()
      .single();

    if (error) {
      console.error('Erro ao criar contexto de IA:', error);
      throw error;
    }

    console.log('Contexto de IA criado com sucesso:', data);
    return data;
  } catch (error) {
    console.error('Erro ao criar contexto de IA:', error);
    throw error;
  }
};

// Atualizar contexto de IA
export const updateContextoIa = async (id, contextoData) => {
  try {
    console.log('Atualizando contexto de IA:', id, contextoData);

    const { data, error } = await supabase
      .from('contextos_ia')
      .update({
        titulo: contextoData.titulo,
        materia_id: contextoData.materia_id,
        ano_escolar_id: contextoData.ano_escolar_id,
        contexto: contextoData.contexto,
        ativo: contextoData.ativo,
        updated_at: new Date().toISOString()
      })
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error('Erro ao atualizar contexto de IA:', error);
      throw error;
    }

    console.log('Contexto de IA atualizado com sucesso:', data);
    return data;
  } catch (error) {
    console.error('Erro ao atualizar contexto de IA:', error);
    throw error;
  }
};

// Excluir contexto de IA
export const deleteContextoIa = async (id) => {
  try {
    console.log('Excluindo contexto de IA:', id);

    const { error } = await supabase
      .from('contextos_ia')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Erro ao excluir contexto de IA:', error);
      throw error;
    }

    console.log('Contexto de IA excluído com sucesso');
    return true;
  } catch (error) {
    console.error('Erro ao excluir contexto de IA:', error);
    throw error;
  }
};

// Alternar status ativo/inativo
export const toggleContextoIaActive = async (id, ativo) => {
  try {
    console.log('Alterando status do contexto de IA:', id, ativo);

    const { data, error } = await supabase
      .from('contextos_ia')
      .update({ 
        ativo: ativo,
        updated_at: new Date().toISOString()
      })
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error('Erro ao alterar status do contexto de IA:', error);
      throw error;
    }

    console.log('Status do contexto de IA alterado com sucesso:', data);
    return data;
  } catch (error) {
    console.error('Erro ao alterar status do contexto de IA:', error);
    throw error;
  }
};

// Buscar matérias
export const fetchMaterias = async () => {
  try {
    const { data, error } = await supabase
      .from('materias')
      .select('id, nome')
      .order('nome');

    if (error) {
      console.error('Erro ao buscar matérias:', error);
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Erro ao buscar matérias:', error);
    throw error;
  }
};

// Buscar anos escolares
export const fetchAnosEscolares = async () => {
  try {
    const { data, error } = await supabase
      .from('anos_escolares')
      .select('id, nome')
      .order('nome');

    if (error) {
      console.error('Erro ao buscar anos escolares:', error);
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Erro ao buscar anos escolares:', error);
    throw error;
  }
};

// Duplicar contexto de IA
export const duplicateContextoIa = async (id) => {
  try {
    console.log('Duplicando contexto de IA:', id);

    // Buscar o contexto original
    const original = await fetchContextoIaById(id);
    
    // Criar cópia com título modificado
    const duplicateData = {
      titulo: `${original.titulo} (Cópia)`,
      materia_id: original.materia_id,
      ano_escolar_id: original.ano_escolar_id,
      contexto: original.contexto,
      ativo: false // Criar como inativo por padrão
    };

    const newContexto = await createContextoIa(duplicateData);
    console.log('Contexto de IA duplicado com sucesso:', newContexto);
    return newContexto;
  } catch (error) {
    console.error('Erro ao duplicar contexto de IA:', error);
    throw error;
  }
};

// Buscar contextos por filtros
export const fetchContextosByFilters = async (filters = {}) => {
  try {
    let query = supabase
      .from('contextos_ia')
      .select(`
        *,
        materias:materia_id (
          id,
          nome
        ),
        anos_escolares:ano_escolar_id (
          id,
          nome
        )
      `);

    // Aplicar filtros
    if (filters.materia_id) {
      query = query.eq('materia_id', filters.materia_id);
    }

    if (filters.ano_escolar_id) {
      query = query.eq('ano_escolar_id', filters.ano_escolar_id);
    }

    if (filters.ativo !== undefined) {
      query = query.eq('ativo', filters.ativo);
    }

    if (filters.search) {
      query = query.or(`titulo.ilike.%${filters.search}%,contexto.ilike.%${filters.search}%`);
    }

    const { data, error } = await query.order('created_at', { ascending: false });

    if (error) {
      console.error('Erro ao buscar contextos filtrados:', error);
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Erro ao buscar contextos filtrados:', error);
    throw error;
  }
};
